<template>

  <div class="vflex">
    <div class="vflex-row-1">
      
      <creating
        v-if="creating"
        heigth="100%" />

      <div
        class="p-3"
        v-if="!creating">

        <div class="mb-3">
          <job-report-pipeline>
            </job-report-pipeline>
        </div>

        <div class="mb-3">
          <job-report-pipeline-speed
            :grid="gridSpeedPipeline">
            </job-report-pipeline-speed>
        </div>

        <div class="mb-3">
          <job-report-pipeline-conversion
            :grid="gridSpeedConversion">
            </job-report-pipeline-conversion>
        </div>

        <div class="mb-3">
          <job-report-disqualify
            :grid="gridDisqualify">
            </job-report-disqualify>
        </div>

        <div style="overflow: hidden;">
          <div class="row">
            <div class="col-sm">
              <job-report-source
                :grid="gridSource">
                </job-report-source>
            </div>
            <div class="col-sm">
              <job-report-source-hired
                :grid="gridSourceHired">
                </job-report-source-hired>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>

</template>

<script>
import {Chart} from 'highcharts-vue'
import JobReportPipeline from './JobReportPipeline'
import JobReportDisqualify from './JobReportDisqualify'
import JobReportSource from './JobReportSource'
import JobReportSourceHired from './JobReportSourceHired'
import JobReportPipelineSpeed from './JobReportPipelineSpeed'
import JobReportPipelineConversion from './JobReportPipelineConversion'

export default {
  name: 'JobReport',
  components: {
    highcharts: Chart,
    JobReportDisqualify,
    JobReportPipeline,
    JobReportSource,
    JobReportSourceHired,
    JobReportPipelineSpeed,
    JobReportPipelineConversion
  },
  data () {
    return {
      creating: true,
      gridDisqualify: [],
      gridSource: [],
      gridSourceHired: [],
      gridSpeedPipeline: [],
      gridSpeedConversion: []
    }
  },
  computed: {
    job () {
      return this.$store.getters.getJob
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.axios.get(`/accounts/${this.$store.getters.getAccount._id}/jobs/${this.job._id}/reports`).then(result => {
        this.gridDisqualify = result.data.disqualifyReasons
        this.gridSource = result.data.candidateSource
        this.gridSourceHired = result.data.candidateSourceHired
        this.gridSpeedPipeline = result.data.pipelineSpeed
        this.gridSpeedConversion = result.data.pipelineConversion
        this.creating = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Job/JobReport/JobReport.vue